var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('iframe',{staticStyle:{"display":"block","position":"absolute","overflow":"auto","border":"none","width":"100%","height":"calc(100dvh - var(--nav-height))"},attrs:{"sandbox":"allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads","allowfullscreen":"true","src":_vm.url}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c53bf5fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/LineRichMenu/index.vue
// module id = null
// module chunks = 